import * as React from "react"

import {Layout} from "./layout"

const NotFoundPage = () => (
  <Layout>
    <h1>404: Not Found</h1>
    <p>該頁面不存在</p>
  </Layout>
)

export default NotFoundPage
